<div id="mainHeader" class="sidebar" [ngClass]="{ 'expanded': isExpanded, 'collapsed': !isExpanded }">
  <div class="content">
    <div class="sidebar-toggle">
      <div class="menu-hd-icon" (click)="handleSidebarToggle($event)"></div>
    </div>
    <div *ngIf="!data || data.length == 0" class="skeleton">
      <div class="skeleton-icon"></div>
      <div class="skeleton-text"></div>
    </div>
    <ng-container *ngFor="let menu of data let i = index">
      <div *ngIf="menu.display !== false" class="menu-items" [style.--scale-dpad]= "1.02" [attr.dpad] ="DpadZoneType.MEMU" [attr.x-dpad]="0" [attr.y-dpad]="i" [ngClass]="{'active': menu.active, 'multi-line': menu.subName}" (click)="onMenuClick(menu)">
        <div class="menu-item" [ngClass]="getMenuIcon(menu)"></div>
        <div [style]="{display: isExpanded? 'unset' : 'none'}" class="lbl-text">
          <span>{{ menu.name }}</span>
          <span *ngIf="menu.subName" class="sub-name">{{ menu.subName }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>